import React from "react";
import { acc1, botox, botoxMacine, candelaMacine, clatuuMacine, coolMacine, fillerMacine, hydraMacine, leaf, miradryMacine, prosMacine, prpMacine, waldMann, zeronaMacine } from "../assets";

const AllEquipments = () => {
  return (
    <div id="allEquipments">
      <div className="content">
        <div className="item">
          <div className="left">
            <img src={zeronaMacine} alt="" />
          </div>
          <div className="right">
            <div className="productName">
              <img src={leaf} alt="" />
              <h1>Zerona®</h1>
            </div>
            <p className="desc">
              Zerona® is a low-level laser treatment designed to slim or contour
              certain areas of the body. It is considered to be a cold laser
              treatment, but its output doesn't use the extreme cold that
              cryolipolysis treatments such as CoolSculpting do. Zerona uses
              true green laser beams (monochromatic, collimated, and coherent)
              to create small transitory pores for the fatty liquids in fat
              cells to seep out. The fatty liquids are then naturally flushed
              out through the lymphatic system. The result is that the fat cells
              shrink instead of being killed.
            </p>
            <p className="note">Results and Patient Experience May Vary.</p>
          </div>
        </div>
        <div className="item">
          <div className="left">
            <img src={coolMacine} alt="" />
          </div>
          <div className="right">
            <div className="productName">
              <img src={leaf} alt="" />
              <h1>CoolSculpting®</h1>
            </div>
            <p className="desc">
              The CoolSculpting® procedure is FDA-cleared for the treatment of
              visible fat bulges in the submental (under the chin) and
              submandibular (under the jawline) areas, thigh, abdomen and flank,
              along with bra fat, back fat, underneath the buttocks (also known
              as banana roll) and upper arm. It is also FDA-cleared to affect
              the appearance of lax tissue with submental area treatments. The
              CoolSculpting® procedure is not a treatment for weight loss.
              CoolSculpting uses a hand-held vacuum device to freeze and
              permanently destroy fat cells. In the weeks following the
              treatment, the lymphatic system processes the frozen fat cells and
              eliminates them as waste. The procedure is performed in a clinic
              or medical spa.
            </p>
            <p className="note">Results and Patient Experience May Vary.</p>
          </div>
        </div>
        <div className="item">
          <div className="left">
            <img src={candelaMacine} alt="" />
          </div>
          <div className="right">
            <div className="productName">
              <img src={leaf} alt="" />
              <h1>Candela®</h1>
            </div>
            <p className="desc">
              It is a dual wavelength laser platform that combines the fastest
              and most powerful 755 nm Alexandrite laser with an equally
              powerful 1064 nm Nd:YAG laser for high performance treatment
              capabilities in terms of speed, efficacy, ease-of-use,
              performance, safety and patient satisfaction. Candela is one of
              the best laser machines available. It uses two different
              wavelengths of light, Alexandrite and ND:YAG. This means that
              Candela is ideal to treat different hair types and different skin
              types.
            </p>
            <p className="note">Results and Patient Experience May Vary.</p>
          </div>
        </div>
        <div className="item">
          <div className="left">
            <img src={hydraMacine} alt="" />
          </div>
          <div className="right">
            <div className="productName">
              <img src={leaf} alt="" />
              <h1>Hydrafacial®</h1>
            </div>
            <p className="desc">
              Hydrafacial machine delivers gentle cleansing and exfoliation that
              is good for oily and acne-prone skin. The machine can unclog pores
              and remove impurities from the surface of the skin. The serums
              applied help minimize pores and prevent clogging too. The
              HydraFacial machine delivers one of the most potent, non-invasive
              skin resurfacing treatments. It combines cleansing, exfoliation,
              extraction, hydration, and antioxidant protection that removes
              dead skin cells and impurities while simultaneously delivering
              moisturizing serums into the skin.
            </p>
            <p className="note">Results and Patient Experience May Vary.</p>
          </div>
        </div>
        <div className="item">
          <div className="left">
            <img src={prosMacine} alt="" />
          </div>
          <div className="right">
            <div className="productName">
              <img src={leaf} alt="" />
              <h1>Proslimelt®</h1>
            </div>
            <p className="desc">
              A low-frequency Ultrasound soft-tissue mobilization machine that
              targets the sub-cutaneous fat layer in localized zones, with
              clinically proven effectiveness, ideal for any person any size.
              The effortless way to reshaping, slimming and restructuring.
            </p>
            <p className="note">Results and Patient Experience May Vary.</p>
          </div>
        </div>
        <div className="item">
          <div className="left">
            <img src={clatuuMacine} alt="" />
          </div>
          <div className="right">
            <div className="productName">
              <img src={leaf} alt="" />
              <h1>Clatuu®</h1>
            </div>
            <p className="desc">
              CLATUU Alpha is an outstanding and non-invasive fat-freezing
              solution that targets fat deposits in the body. Using
              cryolipolysis to target stubborn deposits of fat CLATUU Alpha is
              an effective solution without any downtime. Clatuu is an
              alternative method to traditional liposuction that is
              non-surgical. The process of cryogenic lipolysis involves freezing
              fat cells. The temperature that is used in Clatuu freezes the fat
              to a degree that allows for the cells to be killed without harming
              the skin surrounding it. You will feel a slight tugging and
              pinching on your skin during the first 5 treatment minutes, but
              the numbing from the cold eventually takes over and the treatment
              is then comfortable.
            </p>
            <p className="note">Results and Patient Experience May Vary.</p>
          </div>
        </div>
        <div className="item">
          <div className="left">
            <img src={miradryMacine} alt="" />
          </div>
          <div className="right">
            <div className="productName">
              <img src={leaf} alt="" />
              <h1>Miradry®</h1>
            </div>
            <p className="desc">
              The miraDry procedure is quick, non-invasive and provides a
              lasting solution for excessive underarm sweat. The handpiece from
              the miraDry System, when placed on the underarm, delivers
              precisely controlled energy to the region where the sweat glands
              reside and eliminates sweat glands non-invasively. The MiraDry
              treatment can dramatically reduce underarm sweat and odor for a
              more comfortable and confident you. It harnesses the power of
              thermal energy to target and eliminates sweat and odor glands.
              Once these glands have been eliminated, they will not grow back.
            </p>
            <p className="note">Results and Patient Experience May Vary.</p>
          </div>
        </div>
        <div className="item">
          <div className="left">
            <img src={waldMann} alt="" />
          </div>
          <div className="right">
            <div className="productName">
              <img src={leaf} alt="" />
              <h1>Waldmann®</h1>
            </div>
            <p className="desc">
              A strictly low-fat diet associated with medium-chain triglyceride
              supplementation is the cornerstone of PIL medical management. The
              absence of fat in the diet prevents chyle engorgement of the
              intestinal lymphatic vessels thereby preventing their rupture with
              ensuing lymph loss.
            </p>
            <p className="note">Results and Patient Experience May Vary.</p>
          </div>
        </div>
        <div className="item">
          <div className="left">
            <img src={prpMacine} alt="" />
          </div>
          <div className="right">
            <div className="productName">
              <img src={leaf} alt="" />
              <h1>Eclipse PRP®</h1>
            </div>
            <p className="desc">
              Eclipse PRP is an autologous system that allows physicians to
              prepare platelet-rich plasma at the point of care. The
              platelet-rich plasma is optimally concentrated with minimal
              amounts of contaminating red and white blood cells. This system
              has been safely used in hundreds of thousands of procedures
              worldwide. Platelet-rich plasma (PRP) therapy uses injections of a
              concentration of a patient's own platelets to accelerate the
              healing of injured tendons, ligaments, muscles and joints. In this
              way, PRP injections use each individual patient's own healing
              system to improve musculoskeletal problems.
            </p>
            <p className="note">Results and Patient Experience May Vary.</p>
          </div>
        </div>
        <div className="item">
          <div className="left">
            <img src={botoxMacine} alt="" />
          </div>
          <div className="right">
            <div className="productName">
              <img src={leaf} alt="" />
              <h1>Botox®</h1>
            </div>
            <p className="desc">
              Botox injections are shots that use a toxin to prevent a muscle
              from moving for a limited time. These shots are often used to
              smooth wrinkles on the face. They're also used to treat neck
              spasms, sweating, overactive bladder, lazy eye and other
              conditions. A very thin needle is used to inject small amounts of
              botulinum toxin into specific muscles. By carefully choosing
              specific muscles, your healthcare provider weakens only the
              wrinkle-producing muscles, preserving your natural facial
              expressions. Botulinum toxin treatment injections usually take
              less than 15 minutes.
            </p>
            <p className="note">Results and Patient Experience May Vary.</p>
          </div>
        </div>
        <div className="item">
          <div className="left">
            <img src={fillerMacine} alt="" />
          </div>
          <div className="right">
            <div className="productName">
              <img src={leaf} alt="" />
              <h1>Filler®</h1>
            </div>
            <p className="desc">
              Dermal fillers plump up wrinkles, smooth lines and restore volume
              in your face. Your healthcare provider injects these substances
              just under your skin. People choose to get dermal fillers to
              enhance their facial features or gain a more youthful appearance.
              Dermal fillers work by boosting the skin's supply of hyaluronic
              acid, dermal fillers revitalise and add volume to the skin,
              instantly diminishing the appearance of lines and wrinkles, and
              giving a natural softer look.
            </p>
            <p className="note">Results and Patient Experience May Vary.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllEquipments;
